import { SupportingDocumentField } from "../utils/useCheckingProfileValidations";

export default function DateValidationStatus({
  validation,
}: {
  validation: Pick<
    SupportingDocumentField,
    "completedDate" | "uncompletedDate"
  >;
}) {
  return (
    <>
      <div className="flex flex-col items-center text-center text-xs">
        <span className="text-center font-medium">Doc Uncompleted Date</span>
        <span className="text-center">
          {validation?.uncompletedDate ?? "-"}
        </span>
      </div>
      <div className="flex flex-col items-center text-center text-xs">
        <span className="text-center font-medium">Doc Completed Date</span>
        <span className="text-center">{validation?.completedDate ?? "-"}</span>
      </div>
    </>
  );
}
